import { render, staticRenderFns } from "./IconDropdown.vue?vue&type=template&id=c1bc4598"
import script from "./IconDropdown.vue?vue&type=script&lang=js"
export * from "./IconDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbsdevops/devops/jenkins-slave/workspace/bizbize-frontend-dev/xpermeet-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c1bc4598')) {
      api.createRecord('c1bc4598', component.options)
    } else {
      api.reload('c1bc4598', component.options)
    }
    module.hot.accept("./IconDropdown.vue?vue&type=template&id=c1bc4598", function () {
      api.rerender('c1bc4598', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Shared/IconDropdown.vue"
export default component.exports